import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { IUserInfo } from '@/modules/shared/interfaces/UserInfo';

export const useUserInfoStore = defineStore('userInfo', () => {
    const userInfo = ref<IUserInfo>({
        id: 'a96c373a-82a7-4a5e-a881-405fe956dde6',
        allowedDomains: ['dundermifflin.com'],
        maxMailboxes: 25,
        maxUsers: 25,
        maxAlerts: 5,
        email: 'michael.scott@dundermifflin.com',
        isAdmin: 'admin',
        name: 'Michael Scott',
        roles: 'admin'
    });

    return {
        // properties
        userInfo
    };
});
